export default __webpack_public_path__ + "static/quality-austria-d54e06f46df0304a7c3cd4a78af3647a.png";